<section class="container-fluild">
  <div class="change-password">

      <h1 class="change-password-title">{{ 'login.change_password' | translate }}</h1>
      <form nz-form [formGroup]="validateNewPasswordForm" class="change-password-form" (ngSubmit)="onConfirmNewPassword()">
        <!-- OLD PASSWORD -->
        <nz-form-item>
          <nz-form-label class="form-label" [nzSm]="24" nzFor="oldPassword">{{ 'login.old_password' | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="oldPasswordErrorTpl">
              <nz-input-group [nzSuffix]="suffixOldPasswordTemplate">
                  <input
                      id="oldPassword"
                      [type]="oldPasswordVisible ? 'text' : 'password'"
                      nz-input
                      formControlName="oldPassword"
                      placeholder="{{ 'login.old_password' | translate }}"
                  />
              </nz-input-group>
              <ng-template #suffixOldPasswordTemplate>
                  <i
                      class="suffix-icon"
                      nz-icon
                      [nzType]="oldPasswordVisible ? 'eye-invisible' : 'eye'"
                      (click)="oldPasswordVisible = !oldPasswordVisible"
                  ></i>
              </ng-template>
              <ng-template #oldPasswordErrorTpl let-control>
                  @if (control.hasError('required')) {
                      {{ 'login.password_required' | translate }}
                  }
                  @if (control.hasError('length')) {
                      {{ 'login.password_length_required' | translate }}
                  }
              </ng-template>
          </nz-form-control>
      </nz-form-item>

      <!-- NEW PASSWORD -->
        <nz-form-item>
              <nz-form-label class="form-label" [nzSm]="24" nzFor="newPassword">{{ 'login.new_password' | translate }}</nz-form-label>
              <nz-form-control [nzErrorTip]="newpasswordErrorTpl">
                  <nz-input-group [nzSuffix]="suffixPasswordTemplate">
                      <input
                          id="newPassword"
                          [type]="newPasswordVisible ? 'text' : 'password'"
                          nz-input
                          formControlName="newPassword"
                          placeholder="{{ 'login.new_password' | translate }}"
                      />
                  </nz-input-group>
                  <ng-template #suffixPasswordTemplate>
                      <i class="suffix-icon" nz-icon nzType="close-circle" nzTheme="outline" (click)="clearPassword()"></i>
                      <div class="suffix-divide"></div>
                      <i
                          class="suffix-icon"
                          nz-icon
                          [nzType]="newPasswordVisible ? 'eye-invisible' : 'eye'"
                          (click)="newPasswordVisible = !newPasswordVisible"
                      ></i>
                  </ng-template>
                  <ng-template #newpasswordErrorTpl let-control>
                      @if (control.hasError('required')) {
                          {{ 'login.password_required' | translate }}
                      }
                      @if (control.hasError('length')) {
                          {{ 'login.password_length_required' | translate }}
                      }
                  </ng-template>
              </nz-form-control>
          </nz-form-item>

          <!-- CONFIRM PASSWORD -->
          <nz-form-item>
              <nz-form-label class="form-label" [nzSm]="24" nzFor="confirmNewPassword">{{
                  'login.confirm_new_password' | translate
              }}</nz-form-label>
              <nz-form-control [nzErrorTip]="confirmNewPasswordErrorTpl">
                  <nz-input-group [nzSuffix]="suffixConfirmPasswordTemplate">
                      <input
                          id="confirmNewPassword"
                          [type]="confirmNewPasswordVisible ? 'text' : 'password'"
                          nz-input
                          formControlName="confirmNewPassword"
                          placeholder="{{ 'login.your_passowrd' | translate }}"
                      />
                  </nz-input-group>
                  <ng-template #suffixConfirmPasswordTemplate>
                      <i
                          class="suffix-icon"
                          nz-icon
                          [nzType]="confirmNewPasswordVisible ? 'eye-invisible' : 'eye'"
                          (click)="confirmNewPasswordVisible = !confirmNewPasswordVisible"
                      ></i>
                  </ng-template>
                  <ng-template #confirmNewPasswordErrorTpl let-control>
                      @if (control.hasError('required')) {
                          {{ 'login.confirm_password_required' | translate }}
                      }
                      @if (control.hasError('error')) {
                          {{ 'login.password_not_match' | translate }}
                      }
                  </ng-template>
              </nz-form-control>
          </nz-form-item>

          <button nz-button class="common-primary-button w-full">{{ 'login.confirm' | translate }}</button>
      </form>
  </div>
</section>
